import React from 'react';
import { Container, Dropdown, Typography, Input } from '@design-system';
import './DeliveryInfos.scss';

export type DeliveryInfosProps = {
    operatorsOptions: {
        id: string;
        label: string;
    }[];
    worksitesOptions: {
        id: string;
        label: string;
    }[];
    selectedOperatorId: string;
    selectedWorksiteId: string;
    deliveryDate: string;
    onOperatorChange: (operatorId: string) => void;
    onWorksiteChange: (worksiteId: string) => void;
    onDeliveryDateChange: (date: string) => void;
    readOnly?: boolean;
};

export const DeliveryInfos: React.FC<DeliveryInfosProps> = ({
    operatorsOptions,
    worksitesOptions,
    selectedOperatorId,
    selectedWorksiteId,
    deliveryDate,
    onOperatorChange,
    onWorksiteChange,
    onDeliveryDateChange,
    readOnly = false
}) => {
    return (
        <Container className="delivery-infos bg-white" padding="small">
            <Typography intrinsic="h4" className="pl-small-medium-spacing mb-small-medium-spacing mt-small-spacing">
                Informations de livraison
            </Typography>

            <Container padding="none">
                <Dropdown
                    options={operatorsOptions}
                    placeholder="Responsable"
                    onOptionChange={(option) => onOperatorChange(option.id)}
                    value={operatorsOptions.find((operator) => operator.id === selectedOperatorId)}
                    disabled={readOnly}
                />

                <Dropdown
                    options={worksitesOptions}
                    placeholder="Chantier"
                    onOptionChange={(option) => onWorksiteChange(option.id)}
                    value={
                        selectedWorksiteId && worksitesOptions.length > 0
                            ? worksitesOptions.find((worksite) => worksite.id === selectedWorksiteId) || null
                            : null
                    }
                    isSearchable={true}
                    disabled={readOnly}
                />

                <Input
                    type="date"
                    placeholder="Date de livraison souhaitée"
                    value={deliveryDate}
                    onValueChange={onDeliveryDateChange}
                    min={new Date().toISOString().split('T')[0]}
                    disabled={readOnly}
                />
            </Container>
        </Container>
    );
};
